// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"681":"Tournaments","797":"Game","810":"NotFound","848":"Register","971":"Category"}[chunkId] + "." + {"681":"ae5f6945","797":"164a5f40","810":"66924d5d","848":"0684a336","971":"1c47e50a"}[chunkId] + ".css";
};